<template>
  <div class="mb-3">
    <text-input v-model="form.name" :error="form.errors.name" label="Operator Name" />
    <text-input v-model="form.code" :error="form.errors.code" label="Operator Code" />
    <text-input v-model="form.contact_name" :error="form.errors.contact_name" label="Contact Name" />
    <text-input v-model="form.contact_email" :error="form.errors.contact_email" label="Contact E-mail" />
    <text-input v-model="form.contact_phone" :error="form.errors.contact_phone" label="Contact Phone" />
    <textarea-input v-model="form.comment" :error="form.errors.comment" label="Comment" />

    <div class="form-check" v-for="Type in types" :key="Type.id">
      <input class="form-check-input" type="checkbox" :value="Type.id" :id="Type.id" v-model="form.types">
      <label class="form-check-label" :for="Type.id">
        {{ Type.name }}
      </label>
    </div>
  </div>
</template>

<script>
import TextInput from '@/Shared/TextInput'
import TextareaInput from '@/Shared/TextareaInput'
import SelectInput from '@/Shared/SelectInput'
import SelectCountry from '@/Shared/SelectCountry'

export default {
  name: 'OperatorForm',
  components: {
    SelectInput,
    SelectCountry,
    TextInput,
    TextareaInput
  },
  props: {
    form: Object,
    types: Object
  }
}
</script>

<style>

</style>
